import { gsap } from 'gsap';

export function initRequestSentResources(parent) {
  if (!parent) return;

  const cards = parent.querySelectorAll('.request-sent-resources__card');
  if (!cards.length) return;

  cards.forEach((card, index) => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
    });

    tl.to(card, {
      opacity: 1,
      y: 0,
      scale: 1.02,
      filter: 'blur(0px)',
      duration: 0.5,
      ease: 'power1.out',
      delay: index * 0.1,
    }).to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
  });
}

export function initAllRequestSentResources(
  selector = '.js-request-sent-resources',
) {
  const blocks = document.querySelectorAll(selector);
  blocks.forEach((block) => initRequestSentResources(block));
}
